import messages from './messages';
import { DEFAULT_LANGUAGE, normalizeLanguage } from './languages';

export { DEFAULT_LANGUAGE, normalizeLanguage, SETTING_LANGUAGES } from './languages';

export function translate(lang, key, params = {}) {
  const code = normalizeLanguage(lang);
  const entry = messages[key];
  if (!entry) return key;
  let text = entry[code] || entry.mm || entry.en || entry.ms || key;
  Object.keys(params).forEach((param) => {
    text = text.replace(new RegExp(`\\{${param}\\}`, 'g'), params[param]);
  });
  return text;
}

/** en, mm, ms — used by $lang() */
export function translateTriple(lang, en, mm, ms) {
  const code = normalizeLanguage(lang);
  const map = { en, mm, ms };
  return map[code] || map.mm || map.en || '';
}
